<div class="parallax-mirror" style="
    visibility: visible;
    z-index: -100;
    position: fixed;
    top: 58.1676px;
    left: 0px;
    overflow: hidden;
    transform: translate3d(0px, 0px, 0px);
    height: 609px;
    width: 100%;
  ">
  <img class="parallax-slider" src="../../../assets/images/parallax-07.jpg" style="
      transform: translate3d(0px, 0px, 0px);
      position: absolute;
      height: 535px;
      width: 100%;
      max-width: none;
    " />
</div>

<!-- HEADER -->
<!-- MAIN -->
<main role="main">
  <!-- Section 1 -->
  <article>


    <header class="section background-green background-transparent text-center" data-parallax="scroll"
      data-image-src="images providental/parallax-07.jpg">
      <div class="line">
        <div class="margin-top-bottom-20">
          <!-- Title Strings -->

          <h1 class="text-white text-size-40 text-thin text-line-height-1">Providental prend sa retraite !</h1>
        </div>
      </div>
    </header>


  </article>
  <!-- Section 2 -->

  <section class="section background-white">
    <div class="full-width text-center"> <img src="../../../assets/images/Covers/Cover pensioen.png" class="center"
        style="margin-top: -210px;">
      <div class="line">
        <h3 class="headline text-thin text-s-size-30">Après 42 ans, nous fermons définitivement nos portes !&nbsp;
          &nbsp;(*)&nbsp;&nbsp;</h3>
        <p class="text-size-20 text-s-size-16 text-thin">C'est avec beaucoup de plaisir et de passion que nous avons été
          à votre service</p>
        <p class="text-size-20 text-s-size-16 text-thin">au cours de toutes ces années. Il est maintenant temps de
          libérer l'agenda <br>
          et de profiter d'une nouvelle étape de vie. <br>
          Nous tenons à vous remercier chaleureusement pour votre confiance de longue date <br>
          ainsi que pour les agréables contacts entretenus au fil des ans.<br>
        </p>
        <p class="text-size-20 text-s-size-16 text-thin"><br>
          <br>
          Par conséquent, ce <strong>site</strong> &nbsp;web, l' <strong>e-shop</strong> ainsi que&nbsp; le
          <strong>programme </strong>de commande<strong> </strong>en ligne <br>
          pour&nbsp;<strong>grossistes </strong>ne seront bientôt plus disponibles.
        </p>
        <p class="text-size-20 text-s-size-16 text-thin">&nbsp;</p>
        <p class="text-size-20 text-s-size-16 text-thin">Certains aspects de Providental se poursuivront sous un autre
          forme dans une contexte international, <br>
          mais à Anvers, l'histoire s'achève ici.&nbsp; &nbsp;</p>
        <p class="text-size-20 text-s-size-16 text-thin"><br>
          Pour toute question concernant des affaires ou dossiers en cours, vous pourrez encore, durant une période
          transitoire limitée dans le temps, vous adresser à&nbsp;info@providental.be / 03 226 00 81/
          order@providental.com</p>
        <p class="text-size-20 text-s-size-16 text-thin">&nbsp;</p>
        <p class="text-size-20 text-s-size-16 text-thin">&nbsp;</p>
        <p class="text-size-20 text-s-size-16 text-thin">Avec nos sincères remerciements pour cette belle aventure,</p>
        <p class="text-size-20 text-s-size-16 text-thin">nous vous adressons&nbsp;</p>
        <p class="text-size-20 text-s-size-16 text-thin">nos salutations distinguées.&nbsp;</p>
        <p class="text-size-20 text-s-size-16 text-thin"> <br>
        </p>
        <p class="text-size-20 text-s-size-16 text-thin">L'équipe Providental</p>
        <p class="text-size-20 text-s-size-16 text-thin"><br>
          (*<em> Providental a été fondée en</em> <strong>1984</strong> <em>avec un changement d'actionnaires en</em>
          <strong>1993</strong>.)&nbsp;
        </p>
      </div>
    </div>
  </section>
  <section class="section background-white padding">
    <div class="line">
      <div class="margin"> </div>
    </div>
  </section>
</main>